import { apiFetch } from "./apiFetch";
import { getApiErrorMessage, normalizeFetchError } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

export async function getVendorDetails(
  companyId: string,
  vendorId: string
) {
  const res = await apiFetch(
    `${API_URL}/vendors/${vendorId}?companyId=${companyId}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać danych dostawcy.")
    );
  }

  return res.json();
}

export async function updateVendorAutoAcceptLimit(
  companyId: string,
  vendorId: string,
  autoAcceptLimit: number
) {
  try {
    const res = await apiFetch(
      `${API_URL}/vendors/${vendorId}?companyId=${companyId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ autoAcceptLimit }),
      }
    );

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(res, "Nie udało się zapisać limitu")
      );
    }

    return res.json();
  } catch (e) {
    throw normalizeFetchError(e, "Nie udało się zaktualizować limitu automatycznej akceptacji");
  }
}
